import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const DesktopNav = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    gap: 3rem;
    align-items: center;
    justify-content: center;
  }
`;

const MobileNav = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;

const MenuButton = styled.button`
  width: 30px;
  height: 20px;
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
  padding: 0;

  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${props => props.theme.colors.black};
    transition: all 0.3s ease;

    &:first-child {
      top: ${props => props.$isOpen ? '50%' : '0'};
      transform: ${props => props.$isOpen ? 'rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      top: 50%;
      transform: translateY(-50%);
      opacity: ${props => props.$isOpen ? '0' : '1'};
    }

    &:last-child {
      bottom: ${props => props.$isOpen ? '50%' : '0'};
      transform: ${props => props.$isOpen ? 'rotate(-45deg)' : 'none'};
    }
  }
`;

const Menu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: ${props => props.theme.colors.cream};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: ${props => props.$isOpen ? '1' : '0'};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  z-index: 1000;
`;

const MenuItem = styled(Link)`
  font-family: ${props => props.theme.fonts.heading};
  font-size: 2rem;
  color: ${props => props.theme.colors.black};
  text-decoration: none;
  margin: 1rem 0;
  transition: color 0.3s ease;
  position: relative;

  &:hover {
    color: ${props => props.theme.colors.brick};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: ${props => props.theme.colors.brick};
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const DesktopMenuItem = styled(Link)`
  font-family: ${props => props.theme.fonts.heading};
  font-size: 1.2rem;
  color: ${props => props.theme.colors.black};
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding: 5px 0;

  &:hover {
    color: ${props => props.theme.colors.brick};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: ${props => props.theme.colors.brick};
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  &.active {
    color: ${props => props.theme.colors.brick};
    &::after {
      width: 100%;
    }
  }
`;

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  const handleOverlayClick = () => {
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <NavContainer>
      <DesktopNav>
        <DesktopMenuItem to="/" className={isActive('/') ? 'active' : ''}>Accueil</DesktopMenuItem>
        <DesktopMenuItem to="/members" className={isActive('/members') ? 'active' : ''}>Membres</DesktopMenuItem>
        <DesktopMenuItem to="/music" className={isActive('/music') ? 'active' : ''}>Musique</DesktopMenuItem>
        <DesktopMenuItem to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</DesktopMenuItem>
      </DesktopNav>
      
      <MobileNav>
        <MenuButton onClick={toggleMenu} $isOpen={isOpen}>
          <span></span>
          <span></span>
          <span></span>
        </MenuButton>

        <Menu $isOpen={isOpen}>
          <MenuItem to="/" onClick={handleLinkClick}>Accueil</MenuItem>
          <MenuItem to="/members" onClick={handleLinkClick}>Membres</MenuItem>
          <MenuItem to="/music" onClick={handleLinkClick}>Musique</MenuItem>
          <MenuItem to="/contact" onClick={handleLinkClick}>Contact</MenuItem>
        </Menu>
      </MobileNav>
    </NavContainer>
  );
}

export default Navigation;
